module.exports = __webpack_public_path__ + "media/discovery-ui/assets/tab-option-illustrated-9f6ceae451a5c34c48ac166f3a34bcdf.svg";